(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/deposit-restriction/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/accountservices/deposit-restriction/assets/javascripts/prescript.js');
"use strict";


svs.accountservices = svs.accountservices || {};
svs.accountservices.deposit_restriction = svs.accountservices.deposit_restriction || {};

 })(window);